import { useCallback } from 'react'

import { useConfigurationContext } from '../../context/configurationContext'
import { useMappingId } from '../../system/useMappingId'
import {
  getGlMapOperationAtDate,
  getGlMapOperationFromDate,
  getGlMapOperationMappingId,
} from '../../uiModels/glMapOperations/helpers'
import type { IndexedGlMapOperationWithMetaData } from '../../uiModels/glMapOperations/types'
import { useApplicationViewOperationsContext } from '../../workspace/applicationViewOperationsContext'

/**
 * Tells whether a GL-map version is the one in effect at the current view date, ie. the
 * version the viewer is currently showing.
 */
export const useIsGlMapVersionActive = () => {
  const { viewAt } = useConfigurationContext()
  const mappingId = useMappingId()
  const { applicationGlMaps } = useApplicationViewOperationsContext()
  const activeOperation = getGlMapOperationAtDate(
    applicationGlMaps.get(mappingId),
    viewAt,
  )?.internalOperation

  return useCallback(
    (version: IndexedGlMapOperationWithMetaData) =>
      !!activeOperation &&
      getGlMapOperationFromDate(version.internalOperation) ===
        getGlMapOperationFromDate(activeOperation) &&
      getGlMapOperationMappingId(version.internalOperation) ===
        getGlMapOperationMappingId(activeOperation),
    [activeOperation],
  )
}
